export const ActiveStatus = ['ACTIVE', 'LIMITED', 'LIMITED_REVIEW']

export const StockTitlesToHiddeOnJapan = [
	'Lightspeed',
	'Takion',
	'DAS',
	'CQG',
	'Sterling',
]
export const StockTitlesToHiddeOnMena = [
	'Lightspeed',
	'Takion',
	'DAS',
	'CQG',
	'Sterling',
	'API/FIX',
]
export const ForexTitlesToHiddeOnMena = ['cTrader']

// EMAILS
export const EmailLTD = 'support@tvmarkets.com'
export const EmailLATAM = 'operation@tvmarkets.com'
export const EmailJAPAN = 'japanesesupport@tvmarkets.com'
export const EmailMENA = 'ar@tvmarkets.com'

// PHONES
export const phoneLTD = '+1 (345) 945 6271'
export const phoneLATAM = ''
export const phoneMENA = '+34647457649'

// Langs
export const LangsLTD = ['en', 'es']
export const LangsLATAM = ['en', 'es', 'pt', 'zh', 'ko']
export const LangsMENA = ['ar', 'en']
export const LangsJAPAN = ['jp', 'en']
